// extracted by mini-css-extract-plugin
module.exports = {"container":"OldPagination_container__BXBZY","page-btn":"OldPagination_page-btn__YoiAc"};